// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB6rbhV1cAew7ihpT7hzPDs9w0MKvEwQaI",
    authDomain: "mukti-bangladesh.firebaseapp.com",
    projectId: "mukti-bangladesh",
    storageBucket: "mukti-bangladesh.appspot.com",
    messagingSenderId: "996467599229",
    appId: "1:996467599229:web:11ee5c0b474dca36324e14"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app